export default {
  placeholders: {
    delivery_zip_code: 'Postcode',
    delivery_city: 'Stad',
    delivery_street_number: 'Huisnummer',
    delivery_street_name: 'Straatnaam',
    type_your_address: 'Typ je adres',
  },
  errors: {
    address_suggestions_unavailable:
      'Adressuggesties konden niet worden geladen. Je kunt je adres hieronder nog steeds invoeren.',
  },
  buttons: {
    retry: 'Probeer het opnieuw',
  },
};
